export enum EmailTypeEnum {
  CustomerRegistration = 'customerRegistration',
  CustomerResetPassword = 'customerResetPassword',
  PaymentRequired = 'paymentRequired',
  CustomerOrderConfirmation = 'customerOrderConfirmation',
  SellerOrderConfirmation = 'sellerOrderConfirmation',
  CustomerBiddingLost = 'customerBiddingLost',
  CustomerBiddingWon = 'customerBiddingWon',
  CustomerOutbid = 'customerOutbid',
  SellerNewBid = 'sellerNewBid',
  CustomerHighestBid = 'customerHighestBid',
  SellerBiddingSold = 'sellerBiddingSold',
  CustomerDeliveryStatus = 'customerDeliveryStatus',
  VerificationArtworkApproved = 'verificationArtworkApproved',
  VerificationArtworkRejected = 'verificationArtworkRejected',
  SellerArtworkNotSold = 'sellerArtworkNotSold',
  CustomerBuyOffer = 'customerBuyOffer',
  CustomerOfferAccepted = 'customerOfferAccepted',
  CustomerOfferCanceled = 'customerOfferCanceled',
  CustomerOfferRejected = 'customerOfferRejected',
  SellerBuyOffer = 'sellerBuyOffer',
  SellerCourierConfirmation = 'sellerCourierConfirmation',
  SellerOfferAccepted = 'sellerOfferAccepted',
  SellerOfferCanceled = 'sellerOfferCanceled',
  SellerOfferRejected = 'sellerOfferRejected',
  VerificationPublicProfile = 'verificationPublicProfile',
}
